import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./PasswordReset.css";

const PasswordResetPage = () => {
  const [status, setStatus] = useState({ type: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const requestResetLink = async () => {
    setSubmitting(true);
    setStatus({ type: "", message: "" });

    try {
      const response = await fetch(
        "https://admin.riymay.com/api/v1/admin/password-reset/request-link",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Unable to send reset link right now.");
      }

      setStatus({
        type: "success",
        message:
          data.message ||
          "If the owner account is configured, a reset link has been sent.",
      });
    } catch (error) {
      setStatus({
        type: "error",
        message: error.message || "Unable to send reset link right now.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="password-reset-container">
      <div className="password-reset-card">
        <h2>Reset Admin Password</h2>
        <p>
          For security, password reset links are only sent to the website
          owner&apos;s configured email address.
        </p>

        {status.message ? (
          <div className={`reset-status reset-status-${status.type}`}>
            {status.message}
          </div>
        ) : null}

        <button
          className="submit-button"
          onClick={requestResetLink}
          disabled={submitting}
        >
          {submitting ? "Sending reset link..." : "Send reset link"}
        </button>

        <Link to="/login" className="reset-back-link">
          Back to login
        </Link>
      </div>
    </div>
  );
};

export default PasswordResetPage;
